import { Controller } from "@hotwired/stimulus";

const lastWorkspaceStorageKey = "workstream.lastWorkspaceSlug";

export default class extends Controller<HTMLSelectElement> {
  connect() {
    this.persist();
  }

  change() {
    this.persist();
    window.location.assign(`/workspaces/${this.element.value}`);
  }

  private persist() {
    window.localStorage.setItem(lastWorkspaceStorageKey, this.element.value);
  }
}
